import { CalendarEvent } from 'interfaces/calendar.interface';
import Status from 'interfaces/status.class';
import { RoleTaskFull } from 'interfaces/roleTask.interface';
import { TaskUserUtils } from 'utils/taskUser.utils';
import { dayjs } from '@umanforge/common';

const radius = [
  '4px',
  '4px 4px 0px 0px',
  '0px 0px 4px 4px',
  '0px',
];

const eventStyleGetter = (
  event : CalendarEvent,
  highlightMyTasks ?: boolean,
  me ?: { id : string } | null,
  allRoleTasks ?: Map<string, RoleTaskFull[]>,
  showOnlyMyTasks ?: boolean
) => {
  const backgroundColor = Status.statusToColor( event.task?.status as string );
  let style = {
    backgroundColor: backgroundColor,
    borderRadius: '4px',
    color: 'black',
    border: '0px',
    display: 'block',
    boxShadow: '0px 0px 4px rgb(255, 255, 255)',
    zIndex: '',
    marginLeft: '',
    marginRight: '',
    borderLeft: '',
    maxWidth: '',
    borderInline: '',
    padding: 0
  };

  // event allDay ( vertical bar )
  if ( event.allDayIndicator ) {
    const end = dayjs( event.end );
    const start = dayjs( event.start );
    const borderRadius = radius [
      ( end.isSame( end.endOf( 'day' ) ) ? 1 : 0 ) |
      ( start.isSame( start.startOf( 'day' ) ) ? 2 : 0 )
    ];

    style = {
      ...style,
      backgroundColor: event.allDayColor,
      zIndex: event.allDayOver ? '10' : '',
      boxShadow: event.allDayOver ? '0px 0px 4px rgb(255, 255, 255)' : '',
      borderRadius: borderRadius,
    };
    return { style: style };
  }

  // event allDay ( on top )
  else if ( event.allDay ) {
    style = {
      ...style,
      borderLeft: '0.5rem solid ' + event.allDayColor
    };
  }

  const isMine = me && me.id && event.task && allRoleTasks && TaskUserUtils.isUserAssignedToTask( event.task, me.id, allRoleTasks );
  if ( ( showOnlyMyTasks && !isMine ) || ( highlightMyTasks && !isMine ) ) {
    style = {
      ...style,
      backgroundColor: '#e0e0e0',
      color: '#a0a0a0',
      boxShadow: 'none',
      border: '0px',
    };
    return { style: { ...style, opacity: 0.5 } };
  }
  else if ( highlightMyTasks && isMine ) {
    style = {
      ...style,
      border: '2px solid #1976d2',
      boxShadow: '0px 0px 8px #1976d2',
    };
  }
  return {
    style: style
  };
};

export default eventStyleGetter;